import "./App.css";
// import ComposantTest from './composantTest';
// import "./interface-chaine";
import Navigation from "./Navigation";
import {useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import * as intchaine from "./interface-chaine";
import {DEBUG} from "./utilitaires";

function App() {

   //pour le modal
   const [show, setShow] = useState(false);
   const [msgModal, setMsgModal] = useState("");
   const handleClose = () => setShow(false);
   const handleShow = () => setShow(true); 

  //finalement, le lancement de la blockchain sera fait dans Navigation... 
  // useEffect(() => {
  //   document.title = "Traceur";
  //   (async () => {
  //     try {
  //       await intchaine.lancer();
  //       // intchaine.lancer();
  //     } catch {
  //       setMsgModal("problème lors de connexion à la blockchain") 
  //       setShow(true)
  //       // alert("problem lors de la connexion à la blockchain");
  //     }
  //   })();
  // }, []);

  return (
    <>
      <h3 style={{fontFamily: "Georgia, serif", textAlign: "center" }}>
        <strong>TRACEUR - ACCES FOURNISSEURS</strong>
      </h3>

      <Navigation />

      {/* modal pas utilisé */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Profil Fournisseur</Modal.Title>
        </Modal.Header>
        <Modal.Body>{msgModal}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>  

    </>
  );
}

export default App;
